<template>
  <div class="profile-container">
    <div class="page-header">
      <h2>个人中心</h2>
    </div>

    <el-card class="profile-card">
      <el-tabs v-model="activeTab">
        <!-- 基本信息 -->
        <el-tab-pane label="基本信息" name="basic">
          <div class="profile-content">
            <div class="avatar-section">
              <div class="avatar-wrapper">
                <el-avatar :size="120" :src="userInfo.avatar || ''">
                  {{ userInfo.admin_name ? userInfo.admin_name.charAt(0) : 'A' }}
                </el-avatar>
                <el-button size="small" type="primary" class="upload-btn" @click="handleUploadAvatar">
                  <i class="el-icon-upload"></i> 更换头像
                </el-button>
              </div>
            </div>

            <div class="info-section">
              <div class="section-title">个人信息</div>
              <div class="detail-table">
                <div class="detail-row">
                  <div class="detail-label">用户名</div>
                  <div class="detail-value">{{ userInfo.admin_name || '-' }}</div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">真实姓名</div>
                  <div class="detail-value">{{ userInfo.real_name || '-' }}</div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">手机号码</div>
                  <div class="detail-value">{{ userInfo.mobile || '-' }}</div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">邮箱地址</div>
                  <div class="detail-value">{{ userInfo.email || '-' }}</div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">性别</div>
                  <div class="detail-value">
                    {{ userInfo.gender === 1 ? '男' : userInfo.gender === 2 ? '女' : '未知' }}
                  </div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">部门</div>
                  <div class="detail-value">{{ userInfo.department_name || '-' }}</div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">角色</div>
                  <div class="detail-value">
                    <el-tag v-for="role in userInfo.roles" :key="role.id" size="small" style="margin-right: 5px;">
                      {{ role.role_name }}
                    </el-tag>
                    <span v-if="!userInfo.roles || userInfo.roles.length === 0">-</span>
                  </div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">状态</div>
                  <div class="detail-value">
                    <el-tag :type="userInfo.status === 1 ? 'success' : 'danger'" size="small">
                      {{ userInfo.status === 1 ? '正常' : '禁用' }}
                    </el-tag>
                  </div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">创建时间</div>
                  <div class="detail-value">{{ userInfo.create_time || '-' }}</div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">最后登录时间</div>
                  <div class="detail-value">{{ userInfo.last_login_time || '-' }}</div>
                </div>
              </div>

              <div class="action-buttons">
                <el-button type="primary" @click="showEditDialog">编辑资料</el-button>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <!-- 修改密码 -->
        <el-tab-pane label="修改密码" name="password">
          <div class="password-content">
            <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-width="120px" style="max-width: 500px;">
              <el-form-item label="原密码" prop="old_password">
                <el-input v-model="passwordForm.old_password" type="password" placeholder="请输入原密码" show-password />
              </el-form-item>
              <el-form-item label="新密码" prop="new_password">
                <el-input v-model="passwordForm.new_password" type="password" placeholder="请输入新密码" show-password />
              </el-form-item>
              <el-form-item label="确认密码" prop="confirm_password">
                <el-input v-model="passwordForm.confirm_password" type="password" placeholder="请再次输入新密码" show-password />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleChangePassword">确认修改</el-button>
                <el-button @click="resetPasswordForm">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 登录日志 -->
        <el-tab-pane label="登录日志" name="logs">
          <div class="logs-content">
            <el-table v-loading="logLoading" :data="loginLogs" border style="width: 100%">
              <el-table-column prop="id" label="ID" width="80" />
              <el-table-column prop="login_ip" label="登录IP" width="150" />
              <el-table-column prop="login_location" label="登录地点" width="200" />
              <el-table-column prop="browser" label="浏览器" width="150" />
              <el-table-column prop="os" label="操作系统" width="150" />
              <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
                    {{ scope.row.status === 1 ? '成功' : '失败' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="login_time" label="登录时间" width="180" />
              <el-table-column prop="remark" label="备注" />
            </el-table>

            <div class="pagination">
              <el-pagination
                :current-page="logPagination.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="logPagination.limit"
                :total="logPagination.total"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleLogSizeChange"
                @current-change="handleLogCurrentChange"
              />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 编辑资料对话框 -->
    <el-dialog title="编辑资料" :visible.sync="editDialogVisible" width="600px">
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="真���姓名" prop="real_name">
          <el-input v-model="editForm.real_name" placeholder="请输入真实姓名" />
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model="editForm.mobile" placeholder="请输入手机号码" />
        </el-form-item>
        <el-form-item label="邮箱地址" prop="email">
          <el-input v-model="editForm.email" placeholder="请输入邮箱地址" />
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-radio-group v-model="editForm.gender">
            <el-radio :label="0">未知</el-radio>
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleUpdateProfile">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo, changePassword } from '../api/auth'
import { updateUser, getLoginLogList } from '../api/system'

export default {
  name: 'Profile',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (this.passwordForm.confirm_password !== '') {
          this.$refs.passwordForm.validateField('confirm_password')
        }
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.passwordForm.new_password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      activeTab: 'basic',
      userInfo: {},
      editDialogVisible: false,
      editForm: {
        real_name: '',
        mobile: '',
        email: '',
        gender: 0
      },
      editRules: {
        real_name: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      passwordForm: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      passwordRules: {
        old_password: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        new_password: [
          { required: true, validator: validatePass, trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      },
      loginLogs: [],
      logLoading: false,
      logPagination: {
        page: 1,
        limit: 10,
        total: 0
      }
    }
  },
  created() {
    this.fetchUserInfo()
  },
  methods: {
    async fetchUserInfo() {
      try {
        const userInfoStr = localStorage.getItem('userInfo')
        if (userInfoStr) {
          this.userInfo = JSON.parse(userInfoStr)
        }
        // 也可以从接口获取最新信息
        // const response = await getUserInfo()
        // this.userInfo = response.data
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    },

    showEditDialog() {
      this.editForm = {
        real_name: this.userInfo.real_name || '',
        mobile: this.userInfo.mobile || '',
        email: this.userInfo.email || '',
        gender: this.userInfo.gender || 0
      }
      this.editDialogVisible = true
    },

    async handleUpdateProfile() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          try {
            await updateUser({
              id: this.userInfo.id,
              ...this.editForm
            })
            this.$message.success('更新成功')
            this.editDialogVisible = false
            // 更新本地用户信息
            Object.assign(this.userInfo, this.editForm)
            localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
          } catch (error) {
            console.error('更新失败:', error)
            this.$message.error('更新失败')
          }
        }
      })
    },

    handleUploadAvatar() {
      this.$message.info('头像上传功能开发中...')
    },

    handleChangePassword() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (valid) {
          try {
            // 调用修改密码接口
            await changePassword(this.passwordForm)
            this.$message.success('密码修改成功，请重新登录')
            // 清除登录信息
            localStorage.removeItem('token')
            localStorage.removeItem('userInfo')
            // 跳转到登录页
            setTimeout(() => {
              this.$router.push('/login')
            }, 1500)
          } catch (error) {
            console.error('修改密码失败:', error)
            this.$message.error('修改密码失败')
          }
        }
      })
    },

    resetPasswordForm() {
      this.$refs.passwordForm.resetFields()
    },

    async fetchLoginLogs() {
      this.logLoading = true
      try {
        const params = {
          page: this.logPagination.page,
          limit: this.logPagination.limit,
          user_id: this.userInfo.id
        }
        const response = await getLoginLogList(params)
        this.loginLogs = response.data.list || []
        this.logPagination.total = response.data.total || 0
      } catch (error) {
        console.error('获取登录日志失败:', error)
      } finally {
        this.logLoading = false
      }
    },

    handleLogSizeChange(size) {
      this.logPagination.limit = size
      this.fetchLoginLogs()
    },

    handleLogCurrentChange(page) {
      this.logPagination.page = page
      this.fetchLoginLogs()
    }
  },
  watch: {
    activeTab(val) {
      if (val === 'logs') {
        this.fetchLoginLogs()
      }
    }
  }
}
</script>

<style scoped>
.profile-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 24px;
  color: #303133;
}

.profile-card {
  background: #fff;
}

.profile-content {
  display: flex;
  gap: 40px;
}

.avatar-section {
  flex-shrink: 0;
}

.avatar-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.upload-btn {
  margin-top: 10px;
}

.info-section {
  flex: 1;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
  padding-left: 10px;
  border-left: 4px solid #409EFF;
  line-height: 20px;
}

.detail-table {
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;
  margin-bottom: 20px;
}

.detail-row {
  display: flex;
  border-bottom: 1px solid #EBEEF5;
  min-height: 50px;
  align-items: center;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-weight: 500;
  color: #606266;
  width: 150px;
  text-align: right;
  padding: 15px 20px;
  background-color: #FAFAFA;
  border-right: 1px solid #EBEEF5;
  flex-shrink: 0;
  box-sizing: border-box;
}

.detail-value {
  color: #303133;
  word-break: break-word;
  padding: 15px 20px;
  flex: 1;
  box-sizing: border-box;
}

.action-buttons {
  text-align: left;
  margin-top: 20px;
}

.password-content {
  padding: 20px 0;
}

.logs-content {
  padding: 20px 0;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.dialog-footer {
  text-align: right;
}
</style>

